import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'antd/dist/antd.css';
import './App.css';

// Components
import Login from './components/Auth/Login';
import SuperAdminDashboard from './components/Dashboard/SuperAdminDashboard';
import CompanyManagement from './components/Company/CompanyManagement';
import AddCompany from './components/Company/AddCompany';
import EditCompany from './components/Company/EditCompany';
import PackageManagement from './components/Package/PackageManagement';
import Analytics from './components/Analytics/Analytics';
import Layout from './components/Layout/Layout';

// Contexts
import { AuthProvider } from './contexts/AuthContext';

// Utils
import PrivateRoute from './utils/PrivateRoute';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'disabled';

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ConfigProvider>
        <AuthProvider>
          <Router>
            <div className="App">
              <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<Login />} />
                
                {/* Private Routes */}
                <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="dashboard" element={<SuperAdminDashboard />} />
                  <Route path="companies" element={<CompanyManagement />} />
                  <Route path="companies/add" element={<AddCompany />} />
                  <Route path="companies/edit/:id" element={<EditCompany />} />
                  <Route path="packages" element={<PackageManagement />} />
                  <Route path="analytics" element={<Analytics />} />
                </Route>
                
                {/* Catch all route */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </div>
          </Router>
        </AuthProvider>
      </ConfigProvider>
    </GoogleOAuthProvider>
  );
}

export default App;